import { computed } from "vue";
import { useStore } from "vuex";

/**
 * Rooms Store Helpers
 * Provides simplified access to rooms getters and actions
 */
export function useRoomsStore() {
  const store = useStore();

  // States
  const state = {
    roomList: computed(() => store.state.myPatients.rooms.roomList),
    currentRoomId: computed(() => store.state.myPatients.rooms.currentRoomId),
    topRoomId: computed(() => store.state.myPatients.rooms.topRoomId),
    currentChangeUnreadRoom: computed(() => store.state.myPatients.rooms.currentChangeUnreadRoom),
  };
  // Getters
  const getters = {
    getPatientByRoomId: (roomId) => store.getters["myPatients/rooms/getPatientByRoomId"](roomId),
    currentRoomId: computed(() => store.state.myPatients.rooms.currentRoomId),
    roomList: computed(() => store.state.myPatients.rooms.roomList),
    topRoomId: computed(() => store.state.myPatients.rooms.topRoomId),
    currentChangeUnreadRoom: computed(() => store.state.myPatients.rooms.currentChangeUnreadRoom),
  };

  // Actions
  const actions = {
    // Add rooms actions here as needed
    setRoomList: (roomList) => store.dispatch("myPatients/rooms/setRoomList", roomList),
    addRoom: (roomData) => store.dispatch("myPatients/rooms/addRoom", roomData),
    setCurrentRoomId: (roomId) => store.dispatch("myPatients/rooms/setCurrentRoomId", roomId),
    setUnreadCount: (roomId, unreadCount) => store.dispatch("myPatients/rooms/setUnreadCount", { roomId, unreadCount }),
    updateRoomLastMessage: (roomId, message) => store.dispatch("myPatients/rooms/updateRoomLastMessage", { roomId, message }),
    updateTopRoomId: (roomId) => store.dispatch("myPatients/rooms/updateTopRoomId", roomId),
    updateCurrentChangeUnreadRoom: (roomId, unreadCount) => store.dispatch("myPatients/rooms/updateCurrentChangeUnreadRoom", { roomId, unreadCount }),
  };

  return {
    state,
    getters,
    actions,
  };
}
